import * as React from "react";

interface SVGRProps {
	title?: string;
	titleId?: string;
}

function SvgMinus({
	title,
	titleId,
	...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
	return (
		<svg
			width={24}
			height={24}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			aria-labelledby={titleId}
			{...props}
		>
			{title ? <title id={titleId}>{title}</title> : null}
			<path d="M18 13a1 1 0 100-2H6a1 1 0 100 2h12z" />
		</svg>
	);
}

const MemoSvgMinus = React.memo(SvgMinus);
export default MemoSvgMinus;
